/* assets/combo-pods.js — Petal Combo -> Pods auto-add (UK, v1, 2026-10-22)
 * Adds the mapped Pods variant on EVERY Petal combo add (one-time or
 * subscription), dedupes against the cart, ignores non-combo adds.
 */
(function () {
  'use strict';
  var BUNDLE_CONFIG = {
    '46244163748083': '54903123902846'  // Petal Ultrasonic Combo (£35) -> Petal Cleaning Pods (£19)
  };
  var ADDING = false;
  var lastMutation = 0;

  function comboVariantOf(data) {
    try {
      if (data.items && Array.isArray(data.items)) {
        for (var i = 0; i < data.items.length; i++) {
          var id = data.items[i].id ? String(data.items[i].id) : null;
          if (id && BUNDLE_CONFIG[id]) return id;
        }
        return null;
      }
      var vid = data.id ? String(data.id) : null;
      return vid && BUNDLE_CONFIG[vid] ? vid : null;
    } catch (e) { return null; }
  }
  function cartHasVariant(variant) {
    return fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) return false; return r.json(); })
      .then(function (c) {
        return (c.items || []).some(function (it) { return String(it.variant_id) === String(variant); });
      })
      .catch(function () { return false; });
  }
  function addPodsIfMissing(variant) {
    if (ADDING || !variant) return Promise.resolve();
    ADDING = true;
    return cartHasVariant(variant).then(function (present) {
      if (present) return false;
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant, quantity: 1 })
      }).then(function () { return true; }).catch(function () { return false; });
    }).catch(function () { return false; }).finally(function () { ADDING = false; });
  }
  function scheduleCheck() {
    lastMutation = Date.now();
    setTimeout(function () {
      if (Date.now() - lastMutation > 6000) return;
      fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) {
          if (!c || !c.items) return;
          var combo = null;
          for (var i = 0; i < c.items.length; i++) {
            var vid = String(c.items[i].variant_id);
            if (BUNDLE_CONFIG[vid]) combo = BUNDLE_CONFIG[vid];
          }
          if (combo && !c.items.some(function (it) { return String(it.variant_id) === String(combo); })) {
            addPodsIfMissing(combo);
          }
        })
        .catch(function () {});
    }, 1200);
  }
  var originalFetch = (window.fetch && window.fetch.bind(window)) || null;
  if (!originalFetch) return;
  window.fetch = function (input, init) {
    var url = '';
    try { url = String((input && (input.url || input)) || ''); } catch (e) {}
    if (/\/cart\/add\.js(\?|$)/i.test(url)) {
      var body = null;
      try { body = typeof init.body === 'string' ? JSON.parse(init.body) : (init.body || null); } catch (e) {}
      var combo = body ? comboVariantOf(body) : null;
      if (combo) {
        scheduleCheck();
        return originalFetch.apply(this, arguments).then(function (response) {
          try { if (response.ok) addPodsIfMissing(BUNDLE_CONFIG[combo]); } catch (e) {}
          return response;
        });
      }
    }
    return originalFetch.apply(this, arguments);
  };
  try {
    document.addEventListener('cart:updated', scheduleCheck);
    document.addEventListener('cart:refresh', scheduleCheck);
    window.addEventListener('pageshow', scheduleCheck);
    document.addEventListener('DOMContentLoaded', scheduleCheck);
  } catch (e) {}
  scheduleCheck();
})();